import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { activeDashboardSelector } from '@src/store/tempDashboard/selectors';
import { metricsStore } from '@globalStore/metricsStore';
import { EVENT_BASED_PRESET_KEYS, NETWORK_BASED_PRESET_KEYS } from '@src/utils/presets/constants';
import { isAppModule } from '@src/utils/constants';
import { MetricInfo } from '@src/pages/Alert/manualAlert/constants';

function useFlowMetrics({ selectedMetricList, lockedMetricsSet }) {
  const { flowConfigMeta, metricsGroupedByCategory } = metricsStore.getState();
  const { usecaseKey }: any = useSelector(activeDashboardSelector);
  const initialState: any = {
    flowMetricCategory: {},
    flowMetricCategories: {},
    flowMetricCategoryKeys: {},
    flowMetricCategoryOrder: [],
  };

  const flowMetricData = useMemo(() => {
    const limitationsKeys = EVENT_BASED_PRESET_KEYS.concat(NETWORK_BASED_PRESET_KEYS);
    if (!flowConfigMeta || limitationsKeys.includes(usecaseKey)) return initialState;
    const flowMetrics = Object.keys(flowConfigMeta).reduce((acc, flowKey: any, index: number) => {
      const flowMetricMeta = flowConfigMeta[flowKey];
      let flowMetrics = [];
      if (isAppModule) {
        flowMetrics = metricsGroupedByCategory.app[flowKey]
          ? Object.values(metricsGroupedByCategory.app[flowKey])
          : [];
      } else {
        return acc;
      }
      if (!flowMetrics.length) return acc;
      flowMetrics = flowMetrics.sort((a: any, b: MetricInfo) => a.name.localeCompare(b.name));
      acc.flowMetricCategories[flowKey] = flowMetrics
        .filter((metric: MetricInfo) => {
          return metric.active;
        })
        .map((metric: MetricInfo) => ({
          key: metric.id,
          label: metric.name,
          checked: selectedMetricList.includes(metric.id),
          unit: metric.unit,
          name: `${metric.displayName} ${metric.subscript}`,
          disabled: lockedMetricsSet.has(metric.id),
          isHeavyMetric: metric.isHeavyMetric ?? false,
          definitionStatus: metric.definitionStatus,
          percentileMetrics: metric.percentileMetrics ?? [],
          isDeployed: metric.isDeployed,
        }));
      acc.flowMetricCategoryOrder.push(flowKey);
      acc.flowMetricCategoryKeys[flowKey] = flowKey;
      acc.flowMetricCategory[flowKey] = {
        displayName: flowMetricMeta.name,
        order: index,
      };
      return acc;
    }, initialState);
    return flowMetrics;
  }, [selectedMetricList, flowConfigMeta, usecaseKey]);

  return flowMetricData;
}

export default useFlowMetrics;
